import React from 'react';
import editIcon from '../img/edit.svg';

export const kk = {
  choose_file_registry: 'Тізілімді жүктеу',
  account: 'Дербес шот',
  invoice: 'Шот-фактура',
  registry_field_number: 'Нөмір',
  registry_field_account: 'Дербес шот',
  registry_field_invoice: 'Шот-фактура',
  registry_field_amount: 'Сома',
  account_already_exist: 'Бұл дербес шот кестеде бар',
  invoice_already_exist: 'Бұл шот-фактура кестеде бар',
  registry_identifier_required:
    'Нөмірді/ дербес шотты/ шот-фактураны енгізіңіз (ең болмағанда бір жиек)',
  ACCOUNT_DOES_NOT_BELONG_TO_CUSTOMER:
    'Бұл дербес шот көрсетілген БСН-ге тиесілі емес',

  registry_bin_confirmation:
    'Тізілімдегі деректер көрсетілген БСН-ге тиесілі емес. Төлемді жалғастырғыңыз келетініне сенімдісіз бе?',
  INVOICE_DOES_NOT_BELONG_TO_CUSTOMER:
    'Бұл шот-фактура көрсетілген БСН-ге тиесілі емес',

  loading_recognition_header: 'Тапсырма жүктелуде',
  loading_recognition_body: 'Төлем тапсырмасы өңделуде...',
  loading_recognition_init:
    'Тапсырма жүктелуде. Күте тұрыңыз. Төлем тапсырмаңыз өңделу кезегінде тұр.',
  num_format: 'Телефон нөмірі',
  field_password: 'Пароль',
  field_logout: 'Щығу',
  field_login: 'Кіру',
  corp_info: 'Жалпы ақпарат',
  corp_name: 'Ақша жөнелтуші компанияның атауы',
  corp_address: 'Мекенжайы',
  corp_bin: 'Ақша жөнелтушінің БСН-і',
  corp_phone: 'Телефон нөмірі',
  corp_bank_name: 'Банк',
  corp_bic: 'БИК',
  corp_iban: 'IBAN',
  corp_numbers: 'Нөмірлер',
  corp_number: 'Нөмір',
  corp_account_number: 'Дербес шот нөмірі',
  corp_tariff: 'Тарифтік жоспар',
  corp_balance: 'Теңгерім',
  corp_state: 'Жай-күйі',
  documents_report: 'Есеп құжаттары',
  corp_file_download_error: 'Файлдар жүктелмеді, қате серверде',
  settings_email: 'Электрондық мекенжай',
  street: 'көш.',
  block: 'блок',
  loading: 'Жүктелуде...',
  if_num_is_saved:
    'Егер абоненттік нөмірлерге соманы бөлу төлем тапсырмасының мақсатында көрсетілген болса, тізілімді толтыру қажет емес!',
  registry_saved:
    'Егер нөмірлердің барлығы ортақ жеке шотта болса және төлем тапсырмасының мақсатында осы жеке шоттағы абоненттік нөмірлердің бірі және/немесе шот-фактура нөмірі көрсетілсе, тізілімді толтыру қажет емес!',
  usage_details_title: 'Қоңыраулар, хабарламалар және трафик',
  usage_details_communication_title:
    'Құрметті абонент, Нөміріңіз бойынша шот детализациясы сәтті түсірілді. my.kcell.kz арқылы детализацияға тапсырыс беру қызметін пайдаланғаныңыз үшін рақмет.',
  usage_details_description_preamble:
    'Егер Сіз мобильді шоттағы қаржыңыздың неге жұмсалғанын білгіңіз келсе, осы бөлімде Сіз шот детализациясына тапсырыс бере аласыз. Қажет мерзімді таңдаңыз және Сіз қоңыраулар, хабарламалар мен өзіңіз пайдаланған басқа да қызметтер туралы толық есеп аласыз. Детализацияны соңғы 90 күнге алуға болады.',
  usage_details_description_text:
    'Назар аударыңыз! Детализацияны сұратқан жағдайда, Сіздің нөміріңізге шығару күні мен кезеңі туралы ақпараты бар SMS хабарлама жіберіледі.',
  usage_details_start_period: 'Кезеңнің басталуы',
  usage_details_end_period: 'Кезеңнің аяқталуы',
  usage_details_output: 'Шығару',
  usage_details_email: 'Эл. поштамен',
  usage_details_screan: 'Экранға',
  usage_details_file: 'Файлға',
  usage_details_file_format: 'Формат',
  usage_details_include_period: 'қоса санағанда',

  usage_details_get: 'Деректерді сұрату',
  file_format: 'Файл форматы',
  display: 'Шығару',
  on_screen: 'Экранға',
  to_file: 'Файлға',
  to_email: 'Эл. поштамен',
  begining_of_period: 'Кезеңнің басталуы',
  end_of_period: 'Кезеңнің аяқталуы',
  inclusively: 'қоса санағанда',
  usage_details: 'Детализация',

  month: 'Ай',
  year: 'Жыл',
  date_time: 'Күні/уақыты',
  date: 'Күні',
  type: 'Түрі',
  direction: 'Сипаттама',
  desc: 'Сипаттама',
  number: 'Нөмір',
  duration: 'Ұзақтығы',
  units: 'Бірлік',
  amount: 'Құны',

  sum: 'Сома',
  get: 'Сұрату',
  enabled: 'Қосылған',
  disabled: 'Өшірілген',
  enable: 'Қосылу',
  disable: 'Өшіру',
  roaming: 'Роуминг',
  international_calls: 'Халықаралық қоңыраулар',
  find_label: 'Iздеу',

  limit: 'Лимит',
  credit_limit: 'Несиелік лимит',
  balance: 'Теңгерім',
  contacts_data: 'Байланыс мәліметтері',
  bonuses: 'Бонустар',
  payment_methods: 'Төлеу жүйесі',
  services: 'Қызметтер',
  simcard: 'SIM-карта',
  min_8_characters: 'Кем дегенде 8 символ',
  required_field: 'Міндетті түрде толтырылатын жол',
  active: 'Қосулы',
  suspended: 'Бұғаттаулы',
  postpaid: 'Несиелік',
  pia: 'Аванстық',
  manage_block: 'Бұғаттауды басқару',
  cancel: 'Бас тарту',
  sim_change: 'Сим картаны ауыстыру',
  sim_number: 'Сим картаның нөмірі',
  barr_number: 'Бұғаттау',
  unbarr_number: 'Бұғаттан шығару',
  replace: 'Ауыстыру',
  no_data_found: 'Мәлімет табылмады',
  change_service: 'Қызметтер жиынтығын өзгерту',
  no_subscriber_choosen: 'Ешбір абонент таңдалмады',
  previous: 'Алдыңғы',
  next: 'Келесі',
  connect_roaming:
    '«Роуминг» қызметі дұрыс жұмыс істеу үшін «Халықаралық қоңыраулар» қызметін қосу қажет.',
  roaming_connected: '«Роуминг» қызметі сәтті қосылды.',
  service_not_available:
    'Кешіріңіз, сервис уақытша қолжетімсіз. Кейінірек қайталап көріңіз.',
  already_exists_same_app:
    'Осы деректерді қамтитын қосымша бар. Анықтама қызметіне хабарласыңыз.',
  int_calls_connected:
    '«Халықаралық қоңыраулар» қызметі сәтті қосылды.',
  barred: 'Нөмір бұғатталды.',
  unbarred: 'Нөмір бұғаттаудан шығарылды.',
  login_title: 'Корпоративтық кабинетіне кіру',
  login_title_desc:
    'Нөмірлеріңізді басқарғыңыз келе ме? Корпоративтық кабинетімен бұл оңай!',
  payment_history: 'Төлемдер тарихы',
  payment_history_notice:
    'Уақытша төлемдер тарихы есеп айырысудың несиелік әдісін пайдаланатын дербес шоттар үшін ғана қолжетімді',
  usage_details_warning:
    'Қазіргі уақытта қоңыраулар детализациясында дәлсіздіктер болуы мүмкін. Сұрақтар туындаған' +
    ' жағдайда, корпоративтік клиенттерді қолдау орталығына қоңырау шалуыңызды сұраймыз - 8 (727) 258-70-21',
  report_documents: 'Есеп құжаттар',
  fa: 'Дербес шот',
  month0: 'қаңтар',
  month1: 'ақпан',
  month2: 'наурыз',
  month3: 'сәуір',
  month4: 'мамыр',
  month5: 'маусым',
  month6: 'шілде',
  month7: 'тамыз',
  month8: 'қыркүйек',
  month9: 'қазан',
  month10: 'қараша',
  month11: 'желтоқсан',
  sim_change_success_message: 'SIM карта сәтті ауыстырылды.',
  debt: 'Қарыз',
  availableNums: 'Қолжетімді нөмірлердің саны',
  back: 'Тізімге оралу',
  regForm: 'Тіркеу нысаны',
  last_login: 'Жүйеге соңғы рет кіру уақыты : ',
  CUSTOMER_RESTRICTED:
    'Sorry, you have no access to report documents',
  inet_traffic: 'Интернет трафик',
  internet_traffic_gb: '{0} ГБ',
  internet_traffic_mb: '{0} МБ',
  internet_every_day: 'күнделікті',
  service_daily_otf: 'күнделікті {0} теңге',
  service_over: 'Қызметке қосылған трафиктің 1 МБ тарифі',
  service_otf: '{0} теңге',
  activate: 'Қосу',
  data_pack_link: 'https://www.kcell.kz/kk/product/data-packs',
  disable_inet_pack_warning:
    'Are you sure you want to end this subscription? ',
  changeSuccess: 'Done!',
  subscribeTo: 'Subscribe to',
  unsubscribeFrom: 'Unsubscribe from',
  selectProductGroup: 'Select product group',
  selectPack: 'Select data pack',
  BIN_CONFIRMED: 'БСН расталды',
  BIN_NOT_CONFIRMED: 'БСН расталған жоқ',
  PAYMENT_PERMITTED_FOR_KCELL_BRAND_ONLY: 'Бұл Kcell нөмірі емес',
  AVAILABLE_FOR_PAYMENT: 'Төлем үшін қол жетімді',
  download_eregitry_instruction: 'Нұсқаулықты жүктеу (PDF)',
  download_eregitry_example: 'Тізілім үлгісін жүктеу  (CSV)',
  eregister: 'Электрондық тізілім',
  re_registration_number:
    'Егер нөмір қайта ресімделген болса, жеке шотты және төлем тапсырмасын көрсете отырып, тізілімді email@kcell.kz мекенжайына жіберу қажет',
  eregister_desc:
    'Заңды тұлға үшін ұялы байланыс қызметтерін төлеудің ең ыңғайлы тәсілі банктік аударым болып' +
    ' табылады. Егер сіз ұялы байланыс қызметтерін банктік аударым арқылы бірнеше нөмірге бір сомамен жүргізсеңіз, сомалардың абоненттік нөмірлердің теңгерімдеріне уақтылы түсуі үшін абоненттік нөмірлер мен аударылатын сәйкес сомаларды көрсетумен төлем тапсырмасына тізілімді ұсыну қажет. Сомаларды аударуға арналған тізілімдерді жолдау үшін арнайы нысанды пайдаланыңыз.',
  enter_feedback_details: 'Кері байланыс деректерін енгізіңіз.',
  payment_details: 'Төлем деректемелері:',
  eregistry_warning:
    '*Назар аударыңыз! Абоненттік нөмірлерге сомалар демалыс және мейрам күндерін қоспағанда құжаттар алынған сәттен бастап 24 сағат ішінде аударылады. Егер жоғарыда аталған уақыт ішінде абоненттік нөмірлердің теңгерімдеріне сомалар түспеген болса, +7 727 2587021 нөміріне немесе мобильді телефоннан 9099 нөміріне хабарласуды сұраймыз.',
  require_all_fiels: 'Барлық жолақтарды толтырыңыз',
  require_bin: 'БСН көрсетуіңізді өтінеміз',
  require_company_name: 'Компания атауын көрсетуіңізді өтінеміз',
  require_contact_phone:
    'Байланыс телефон нөмірін көрсетуіңізді өтінеміз',
  require_email: 'Пошта көрсетуіңізді өтінеміз',
  require_payment_account: 'Kcell есеп шотын көрсетуіңізді өтінеміз',
  require_payment_order_number:
    'Төлем тапсырмасын көрсетуіңізді өтінеміз',
  require_payment_amount: 'Төлем сомасын көрсетуіңізді өтінеміз',
  require_payment_order_scan:
    'Төлем тапсырмасының сканын тіркеуіңізді өтінеміз',
  require_account_and_amount:
    'Тізілімде нөмірлер мен соманы көрсетуіңізді өтінеміз',
  entered_bin_belongs_to_kcell:
    'Енгізілген БСН KCELL компаниясына тиесілі.',
  amount_do_not_much: 'Сома сай келмейді',
  paymentSum_error:
    'Тізілімдегі сома төлем тапсырмасындағы сомамен сәйкес келмейді. Тізілімді қайта тексеріп, жүктеуді сұраймыз.',
  invalid_bin: 'Қате БСН',
  require_number: 'Нөмірді енгізуіңізді өтінеміз',
  register_send_success: 'Тізілім сәтті жіберілді',
  file_is_large: 'Файл(дар) рұқсат етілген өлшемдерден үлкен',
  save: 'Сақтау',
  close: 'Жабу',
  choose_file: 'Төлем тапсырмасын жүктеу',
  choose_file_numbers: 'Нөмірлер тізілімін жүктеу',
  status: 'Мәртебесі',
  add: 'Қосу',
  delete: 'Жою',
  e_registry_before_upload:
    'Жүктеуден бұрын, файлды келесі форматтардың бірінде сақтау қажет: CSV, XLS, XLSX.',
  numbers: 'Нөмірлер',
  e_registry_numbers_desc:
    'Деректерді ыңғайлы енгізу үшін алдын ала жасалған файлдың көмегімен тізілімді жүктеу мүмкіндігін пайдалана аласыз. Ол үшін Excel бағдарламасында мына үлгі бойынша кесте құруыңыз қажет:',
  send_e_registry: 'Тізілімдi жолдау',
  attention: 'Назар',
  e_registry_upload_desc:
    'Төлемді растау үшін төлем құжатының сканерден өткізілген көшірмесін жүктеңіз.Егер төлем тапсырмасы бүгінгі күнгі құжат болса, құжатқа банк мөрі немесе ұйымыңыздың мөрі қойылуы тиіс.',
  e_registry_upload_warning:
    'Келесі форматтағы 5 МБ аспайтын файлдарды жүктеуге болады (PDF)',
  payment_details_warn:
    'Маңызды! Өтінімдегі деректемелер төлем тапсырмасындағы деректемелермен сәйкес келуі тиіс, кері жағдайда төлем есепке алынбайды.',
  payment_details_info:
    'Жиектерді автоматты түрде толтыру үшін PDF пішімінде банк мөрі бар төлем тапсырмасын жүктеңіз. Ол үшін "Төлем тапсырмасын жүктеу" түймешігін басыңыз.',
  payment_date_info:
    'Егер төлем тапсырмасында валюталау күні көрсетілмесе, осы жолға төлем күнін енгізіңіз. Егер екі күн көрсетілген болса, валюталау күнін енгізіңіз.',
  payment_sum: 'Төлем тапсырмасында көрсетілген сома',
  kcell_payment_account:
    'Бенефициардың ЖСК (Kcell-дің есеп айырысу шоты)',
  payment_order_num: 'Төлем тапсырмасының № *',
  payment_date: 'Валюталау күні',
  read_payment_order_desc:
    'Өрістерді автоматты түрде толтыру үшін төлем тапсырмасының сканерленген көшірмесін жүктеп салыңыз. Өрістерді қолмен толтыру үшін немесе деректер бұрыс оқылған жағдайда «Өңдеу» түймесін басыңыз.',
  read_payment_order_error:
    'Төлем тапсырмасы оқылмады. Өрістерді қолмен толтыру үшін «Өңдеу» түймесін пайдаланыңыз.',
  read_payment_order: 'Төлем тапсырмасын оқып алу',
  edit: 'Өңдеу',
  yes: 'Иә',
  no: 'Жоқ',
  bin_error: 'БСН дұрыстығын тексеріңіз',
  number_already_exist: 'Бұл нөмір кестеде әлдеқашан бар',
  invalid_file_format: 'Файлдың форматы қате',
  same_numbers_in_file: 'Файлда нөмірлер қайталанады',
  numbers_has_been_exceeded: 'Нөмірлердің барынша көп саны - 3500',
  e_registry_send_warning:
    '«Тізілімді жіберу» батырмасын басу арқылы сіз тізілімге енгізілген параметрлердің дұрыстығын растайсыз.',
  require_payment_date: 'Төлем күнін көрсетуіңізді өтінеміз',
  request_has_been_processed:
    'Өтінім өңделуде немесе әлдеқашан өңделді',
  table_contains_error: 'Кесте қатесі бар',
  traffic_volume: 'Трафик көлем',
  MONTHLY_FEE: 'Ай сайынғы абоненттік төлем',
  DAILY_FEE: 'Күн сайынғы абоненттік төлем',
  linkToDesc: 'Сипаттамаға сілтеме',
  mb: 'МБ.',
  confirme_deactivation_of_service:
    'Қызметті сөндіруді растауыңызды өтінеміз',
  service_successfuly_activated: 'Қызмет сәтті қосылды',
  service_successfuly_deactivated: 'Қызмет сәтті сөндірілді',
  invalid_sum_in_file: 'Төлем счеттарында қате бар',
  please_select_date: 'Күнтізбеден қажетті күнді таңдаңыз',
  invoice_title: 'Алдын ала төлем шоты',
  invoice_msisdn: 'Телефон нөмірі',
  invoice_msisdn_format:
    'Введите 11 значный номер в формате +7(7XX)XXXXXXX',
  invoice_bin: '12 таңбалы БСН нөмірін енгізіңіз',
  invoice_org_name: 'Компания атауын енгізіңіз',
  invoice_address: 'Заңды мекенжайын енгізіңіз',
  invoice_payment_account: 'Есеп айырысу шотының нөмірін енгізіңіз',
  invoice_payment_amount: 'Төлем сомасын енгізіңіз',
  invoice_payment_min_amount:
    'Төлем сомасын енгізіңіз, кем дегенде 100 теңге болуы тиіс',
  invoice_service_type: 'Выберите тип сервиса',
  invoice_payment_for_equipment: 'Жабдық үшін',
  invoice_payment_for_service: 'Байланыс қызметтері үшін',
  invoice_payment_for_equipment_doc:
    'Авансовый платеж за оборудование',
  invoice_payment_for_service_doc:
    'Авансовый платеж за услуги сотовой связи',
  invoice_generate_pdf: 'Жүктеу',
  sim_change_disable_alert: 'Қызмет уақытша қол жетімсіз.',
  report_docs_restricted:
    'Құрметті абонент, жаңа AMDOCS биллинг жүйесін бейімдестіруге қатысты техникалық себептерге байланысты 01.07.2016 мен 31.03.2017 аралығындағы кезең үшін салық шот-фактуралары email@kcell.kz электрондық мекенжайына хабарлассаңыз, Сізге жеке тәртіпте ұсынылады. Уақытша ыңғайсыздықтар үшін кешірім сұраймыз.',
  disabled_handbook_description: (
    <div className="service-description">
      <p>
        Мобильді анықтамалық – қалтаңыздағы өз қызметкерлерінің
        байланыс деректерінің анықтамалығы Қызмет есеп айырысудың
        алғытөлемдік және несиелік тәртібін пайдаланатын, Kcell
        абоненті болатын, корпоративтік клиенттер (заңды тұлғалар мен
        жеке кәсіпкерлер) үшін қолжетімді. Тегін смс сұраным арқылы
        кез келген қызметкер өз әріптесі туралы тез арада ақпарат
        алады.
      </p>
      <br />
      <p>
        Мобильді анықтамалық келесі жұмыс проблемаларын жедел шешуге
        көмектеседі:
        <ul>
          <li>жиналысқа кешігіп жатқан әріптестің нөмірін білу</li>
          <li>
            көлік тұрағында қай әріптесіңіз жолыңызды бөгеп тұрғанын
            машина нөмірінен білу
          </li>
          <li>
            сізге қоңырау шалған абоненттің аты-жөні мен лауазымын
            білу
          </li>
        </ul>
      </p>
      <br />
      <p>
        Қызметті жеке кабинетіңіз арқылы бірнеше батырманы басып қана,
        басқару оңай және жеңіл. Сондай-ақ, қызметкерлеріңізді екі
        санатқа бөліп, VIP санатын басқа қызметкерлерге көрінбейтін
        етіп қалдыруға болады, ал VIP санаты өз кезегінде кез келген
        қызметкер туралы ақпаратты көре алады. Қызмет аясында сізге
        4040 тегін сәйкестендіргіші ұсынылады.
      </p>
      <br />
      <p>
        Толығырақ «Кселл» клиенттерімен жұмыс бойынша өз өкіліңізден
        немесе ұялы телефоннан 9099 нөмірі және қалалық нөмірден (727)
        258 70 21 нөмірі бойынша біле аласыз.
      </p>
    </div>
  ),
  enabled_handbook_description: (
    <div className="service-description">
      <p>
        «Мобильді анықтамалық» қызметі бойынша жеке кабинетке қош
        келдіңіз. Тізімдерді бірнеше қарапайым әрекет арқылы өзіңіз
        басқара аласыз.
      </p>
      <br />
      <p>
        Төмендегі кестеде сіз өз қызметкерлеріңіздің деректерін
        жүктей, жоя және өзгерте аласыз. Сондай-ақ, өзіңізге ыңғайлы
        болу үшін тізімді толығымен жаңарта аласыз немесе excel құжат
        жүктеу арқылы толықтыра аласыз.
      </p>
      <br />
      <p>
        Аздаған өзгерістер енгізу үшін қажетті жолаққа курсорды
        апарып, енгізу жеткілікті.
      </p>
      <br />
      <p>
        Бастапқы деректерді енгізу немесе көптеген жолақтар қосу үшін
        өзіңізге ыңғайлы болу үшін келесі қадамдарды орындауыңыз
        қажет:
        <ol>
          <li>excel файл жүктеп шығару</li>
          <li>
            жүктеп шығарылған файлдың жолақтарына қажетті ақпаратты
            енгізу
          </li>
          <li>excel файлды жүктеу</li>
        </ol>
        Әрекеттерді орындағаннан кейін, жүйе деректерді өзі жаңартады.
      </p>
      <br />
      <p>
        Сұрақтарыңыз туындаған жағдайда, «Кселл» клиенттерімен жұмыс
        бойынша өз өкіліңізге немесе ұялы телефоннан 9099 нөміріне
        және қалалық нөмірден (727) 258 70 21 нөміріне хабарласуыңызды
        сұраймыз.
      </p>
    </div>
  ),
  new_cabinet_info_title:
    'Корпоративтік клиенттерге арналған жаңа Кабинет!',
  new_cabinet_info_text: (
    <div style={{ marginLeft: '20px' }}>
      <p>
        Барлық қосылған пайдаланушылар үшін жаңа Кабинет қолжетімді!
        Қолжетімділік алу үшін сілтемемен өтіп, «Құпия сөзді ұмыттыңыз
        ба?» функциясын пайдаланыңыз.
      </p>
      <p>
        Қызметті қосу үшін компанияның мөр басылған фирмалық бланкінде
        өтінімді толтырыңыз (
        <a href="https://static.kcell.kz/b2b/page/cabinet/application-kk.docx">
          өтінім үлгісі
        </a>
        );
      </p>
      <p>
        Корпоративтік Клиенттерді Бірыңғай Қолдау Қызметінің поштасына{' '}
        <a
          href="mailto:email@kcell.kz"
          rel="nofollow"
          title="Follow link"
        >
          email@kcell.kz
        </a>{' '}
        өтінімнің сканерленген нұсқасын жолдау.
      </p>
      <br />
      <p className="small-text">
        <a
          target="_blank"
          href="https://static.kcell.kz/files/kcell/docs/b2b_selfcare_service_instruction.pdf"
        >
          Кабинетті пайдалану туралы нұсқаулықты жүктеу (PDF)
        </a>
        <br />
      </p>
    </div>
  ),
  old_cabinet_title:
    'Корпоративтік клиенттерге арналған Кабинеттің ескі нұсқасы',
  old_cabinet_title_info: (
    <div>
      <p>
        Корпоративтік абоненттерге арналған кабинеттің бұл нұсқасы
        2018 жылдың 15 тамызын қоса алғанда қолжетімді болатынын
        хабарлаймыз. 16.08.2018 ж. бастап Кабинеттің ескі нұсқасы
        жабылады. Барлық қосылған пайдаланушылар үшін жаңа кабинет
        жұмыс істейді!
      </p>
      <p>
        <a target="_blank" href="https://cabinet.kcell.kz/">
          Мына сілтемеге
        </a>{' '}
        өтіңіз және «Құпия сөзіңізді ұмыттыңыз ба?» функциясын
        пайдаланыңыз.
        <br />
      </p>
    </div>
  ),
  visual_src: '/public/images/new-cabinet-visual-kk.jpg',
  training_video: 'Үйретуші видеоны көру',
  training_video_iframe: (
    <iframe
      width="854"
      height="480"
      src="https://www.youtube.com/embed/jtgbCAJzT9M"
      frameBorder={0}
      allowFullScreen={true}
    />
  ),
  null_amount: '0 сомасы рұқсат етілмейді',
  upload_doc_success_message:
    'Деректердің дұрыс оқылғанын және жүктелген төлем тапсырмасымен сәйкес келетінін тексеріңіз. Болмаса, жиектерді қолмен түзетіңіз.',
  upload_doc_error_message1: (
    <span>
      Құжатты лөу мүмкін болмады. Төлем тапсырмасын қайта жүктеңіз.
      Бұған Сізде 1 әрекет қалды. Сондай-ақ
      <img
        style={{ margin: '0px 5px' }}
        src={editIcon}
        alt="edit-icon"
      />
      таңбасын басып, жиектерді қолмен толтыра аласыз.
    </span>
  ),
  upload_doc_error_message2:
    'Құжатты оқу мүмкін болмады. Төлем тапсырмасын қайта жүктеңіз. Бұл үшін Сізде 2 әрекет бар, содан кейін Сіз жиектерді қолмен түзете аласыз.',
  upload_doc_error_message3: (
    <span>
      Құжатты лөу мүмкін болмады.
      <img
        style={{ margin: '0px 5px' }}
        src={editIcon}
        alt="edit-icon"
      />
      таңбасын басып, жиектерді қолмен толтырыңыз.
    </span>
  ),

  sap_hana_migration_notice: `Құрметті абоненттер,

«Кселл» АҚ 2026 жылғы 01 шілдеден бастап есепке алу мен басқарудың жаңа SAP HANA жүйесіне көшетінін хабарлаймыз.
Келісімшарттық міндеттемелер бойынша дербес шоттарға төлемдердің уақтылы түсуін қамтамасыз ету мақсатында, мүмкіндігінше, қызметтер ақысын 2026 жылғы 26–28 маусымнан кешіктірмей қолма-қол ақшасыз есеп айырысу арқылы төлеуді ұсынамыз.

Бұл шара жаңа SAP HANA есепке алу және басқару жүйесіне көшу кезеңінде, сондай-ақ оны көшіргеннен кейінгі тұрақтандыру кезеңінде төлемдерді өңдеу мен есепке алудағы ықтимал кідірістерді азайтуға бағытталған. SAP HANA жүйесі іске қосылғаннан кейін жекелеген процестерді, соның ішінде келіп түсетін ақшалай қаражатты өңдеуді, сәйкестендіруді және бөлуді автоматтандыру бойынша қосымша жұмыстар жүргізілуі мүмкін.

Жүйені көшіру кезеңінде және жаңа SAP HANA жүйесі іске қосылғаннан кейін бірден түскен төлемдер ұзағырақ өңделуі мүмкін екеніне назар аударуыңызды сұраймыз.

Бұл ретте Абоненттердің/Клиенттердің төлем бойынша барлық міндеттемелері, төлемдерді ішкі өңдеу мерзімдеріне қарамастан, шарттардың талаптарына және Қазақстан Республикасының заңнама талаптарына сәйкес орындалды деп есептеледі.
Жасалған шарттардың талаптары өзгеріссіз қалады.

Сұрақтар туындаған жағдайда 8 (727) 258-70-21 телефоны, мобильді телефоннан 9099 нөмірі немесе email@kcell.kz электрондық поштасы арқылы Корпоративтік клиенттерді қолдау қызметіне хабарласа аласыз.`,

  new_erp_registry_notice_intro:
    'Құрметті клиент,\n01.07.2026 жылдан бастап Электрондық тізілім арқылы дербес шот және шот-фактура нөмірі бойынша төлемдерді есепке алу мүмкіндігі қосылды.',

  new_erp_registry_notice_params:
    'Енді тізілімде келесі параметрлердің бірін көрсетуге болады: абоненттік нөмір, дербес шот немесе шот-фактура нөмірі.',

  new_erp_registry_notice_template:
    'Тізілімнің жаңа үлгісін жүктеп алыңыз:',

  new_erp_registry_template_link: 'Тізілім үлгісін жүктеп алу (CSV)',

  new_erp_registry_notice_instruction:
    'Сондай-ақ, өзекті Нұсқаулықпен міндетті түрде танысыңыз:',

  new_erp_registry_instruction_link: 'Нұсқаулықты жүктеп алу (PDF)',
  check_e_registry: 'Тізілімді тексеру',
  eregistry_video_instruction: 'Бейненұсқаулық',
};
